var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.penaliteBascule && _vm.isOnShokz)?_c('div',{staticClass:"text-left section_fiche_penalite"},[_c('v-icon',{staticClass:"icon_penalite",attrs:{"name":"exclamation-triangle"}}),_vm._v(" Bascule - Pénalité 2h ")],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }